import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getRiskLabel } from '../utils/riskUtils';
import './AuditTrail.css';

const MOCK_ENTRIES = [
  {
    id: '1',
    timestamp: '2026-04-09T11:42:00Z',
    submissionId: 'Lone Star Power Solutions',
    actionType: 'ai_scoring',
    scaleType: '1-20',
    industryCode: '221112',
    industryName: 'Electric Power Distribution',
    baseScore: 12,
    tagsApplied: [
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
      { tagId: 'CTR06CYB', label: 'EDR Deployed', adjustment: -2 },
      { tagId: 'EXP09CYB', label: 'Critical Infrastructure', adjustment: +4 },
    ],
    finalScore: 11,
    confidence: 0.87,
    hazardTier: 'orange',
    override: null,
  },
  {
    id: '2',
    timestamp: '2026-04-09T10:18:00Z',
    submissionId: 'QuickLend Financial Corp',
    actionType: 'ai_scoring',
    scaleType: '1-20',
    industryCode: '522310',
    industryName: 'Mortgage Banking',
    baseScore: 11,
    tagsApplied: [
      { tagId: 'EXP03CYB', label: 'PII Volume >100K', adjustment: +3 },
      { tagId: 'EXP06CYB', label: 'Regulatory Exposure', adjustment: +2 },
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
      { tagId: 'CTR05CYB', label: 'Encryption at Rest', adjustment: -1 },
    ],
    finalScore: 12,
    confidence: 0.82,
    hazardTier: 'orange',
    override: null,
  },
  {
    id: '3',
    timestamp: '2026-04-08T16:05:00Z',
    submissionId: 'Meridian Health Partners',
    actionType: 'ai_scoring',
    scaleType: '1-20',
    industryCode: '621111',
    industryName: 'Offices of Physicians',
    baseScore: 10,
    tagsApplied: [
      { tagId: 'EXP03CYB', label: 'PHI/PII Exposure', adjustment: +3 },
      { tagId: 'EXP06CYB', label: 'HIPAA Regulatory', adjustment: +2 },
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
    ],
    finalScore: 12,
    confidence: 0.79,
    hazardTier: 'orange',
    override: null,
  },
  {
    id: '4',
    timestamp: '2026-04-08T14:33:00Z',
    submissionId: 'Apex Digital Marketing LLC',
    actionType: 'ai_scoring',
    scaleType: '1-20',
    industryCode: '541810',
    industryName: 'Advertising Agencies',
    baseScore: 7,
    tagsApplied: [
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
      { tagId: 'CTR05CYB', label: 'Encryption at Rest', adjustment: -1 },
      { tagId: 'CTR06CYB', label: 'EDR Deployed', adjustment: -2 },
      { tagId: 'CTR10CYB', label: 'Security Training', adjustment: -1 },
    ],
    finalScore: 3,
    confidence: 0.93,
    hazardTier: 'green',
    override: null,
  },
  {
    id: '5',
    timestamp: '2026-04-08T11:20:00Z',
    submissionId: 'TrueNorth Legal Advisors',
    actionType: 'manual_override',
    scaleType: '1-20',
    industryCode: '541110',
    industryName: 'Offices of Lawyers',
    baseScore: 13,
    tagsApplied: [
      { tagId: 'EXP07CYB', label: 'Prior Cyber Incident', adjustment: +4 },
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
      { tagId: 'CTR14CYB', label: 'IR Plan Tested', adjustment: -2 },
    ],
    finalScore: 12,
    confidence: 0.76,
    hazardTier: 'orange',
    override: { from: 15, to: 12, reason: 'UW reviewed: incident was minor phishing, full remediation completed, MFA and IR plan now verified. Downgrading to Moderate.' },
  },
  {
    id: '6',
    timestamp: '2026-04-07T15:48:00Z',
    submissionId: 'Summit Retail Group',
    actionType: 'decision',
    scaleType: '1-20',
    industryCode: '452210',
    industryName: 'Department Stores',
    baseScore: 8,
    tagsApplied: [
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
      { tagId: 'CTR06CYB', label: 'EDR Deployed', adjustment: -2 },
      { tagId: 'CTR05CYB', label: 'Encryption at Rest', adjustment: -1 },
    ],
    finalScore: 4,
    confidence: 0.91,
    hazardTier: 'green',
    override: null,
  },
  {
    id: '7',
    timestamp: '2026-04-07T09:15:00Z',
    submissionId: 'CryptoVault Exchange Inc',
    actionType: 'ai_scoring',
    scaleType: '1-20',
    industryCode: '523130',
    industryName: 'Commodity Contracts Dealing',
    baseScore: 16,
    tagsApplied: [
      { tagId: 'EXP11CYB', label: 'Cryptocurrency Operations', adjustment: +4 },
      { tagId: 'EXP03CYB', label: 'PII Volume >100K', adjustment: +3 },
      { tagId: 'CTR01CYB', label: 'MFA Full Org-Wide', adjustment: -3 },
    ],
    finalScore: 18,
    confidence: 0.71,
    hazardTier: 'red',
    override: null,
  },
];

const ACTION_LABELS = {
  ai_scoring: 'AI Scoring',
  manual_override: 'Manual Override',
  decision: 'Decision',
};

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function AuditTrail() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [product, setProduct] = useState('');
  const [decisionType, setDecisionType] = useState('');
  const [underwriter, setUnderwriter] = useState('');

  const filteredEntries = MOCK_ENTRIES.filter((entry) => {
    if (dateFrom && new Date(entry.timestamp) < new Date(dateFrom)) return false;
    if (dateTo && new Date(entry.timestamp) > new Date(dateTo + 'T23:59:59')) return false;
    if (decisionType && entry.actionType !== decisionType) return false;
    return true;
  });

  return (
    <div className="at">
      <h1 className="at__title">AI Decision Audit Trail</h1>

      <div className="at__filters card">
        <div className="at__filter-row">
          <div className="at__filter-group">
            <label className="at__filter-label">Date range</label>
            <div className="at__filter-row-inline">
              <input
                type="date"
                className="at__filter-input"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
              <span className="at__filter-sep">to</span>
              <input
                type="date"
                className="at__filter-input"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </div>
          </div>
          <div className="at__filter-group">
            <label className="at__filter-label">Product</label>
            <select
              className="at__filter-select"
              value={product}
              onChange={(e) => setProduct(e.target.value)}
            >
              <option value="">All products</option>
              <option value="cyber">Cyber & Tech</option>
              <option value="e&o">E&O</option>
            </select>
          </div>
          <div className="at__filter-group">
            <label className="at__filter-label">Decision type</label>
            <select
              className="at__filter-select"
              value={decisionType}
              onChange={(e) => setDecisionType(e.target.value)}
            >
              <option value="">All types</option>
              <option value="ai_scoring">AI Scoring</option>
              <option value="manual_override">Manual Override</option>
              <option value="decision">Decision</option>
            </select>
          </div>
          <div className="at__filter-group">
            <label className="at__filter-label">Underwriter</label>
            <select
              className="at__filter-select"
              value={underwriter}
              onChange={(e) => setUnderwriter(e.target.value)}
            >
              <option value="">All</option>
              <option value="jane">Jane Smith</option>
              <option value="john">John Doe</option>
            </select>
          </div>
        </div>
      </div>

      <div className="at__timeline">
        {filteredEntries.map((entry) => (
          <div key={entry.id} className="at__entry card">
            <div className="at__entry-header">
              <span className="at__entry-time">{formatDate(entry.timestamp)}</span>
              <Link
                to={`/submissions/${entry.submissionId}`}
                className="at__entry-submission"
              >
                {entry.submissionId}
              </Link>
              <span
                className={`at__entry-action at__entry-action--${entry.actionType}`}
              >
                {ACTION_LABELS[entry.actionType] || entry.actionType}
              </span>
            </div>

            <div className="at__entry-meta">
              <span className="at__entry-industry">
                {entry.industryCode} · {entry.industryName}
              </span>
            </div>

            <div className="at__entry-score-flow">
              <span className="at__score-step">Base: {entry.baseScore}/20</span>
              <span className="at__score-arrow">→</span>
              <span className="at__score-tags">
                Tags: {entry.tagsApplied.map((t) => t.adjustment).join(', ')}
              </span>
              <span className="at__score-arrow">→</span>
              <span className="at__score-final">Final: {entry.finalScore}/20</span>
            </div>

            <div className="at__entry-tags">
              {entry.tagsApplied.map((tag, idx) => (
                <span
                  key={idx}
                  className={`at__tag-pill at__tag-pill--${tag.adjustment >= 0 ? 'plus' : 'minus'}`}
                >
                  {tag.tagId && <span className="at__tag-id">{tag.tagId}</span>}
                  {tag.label} {tag.adjustment >= 0 ? '+' : ''}{tag.adjustment}
                </span>
              ))}
            </div>

            <div className="at__entry-confidence">
              <span className="at__confidence-label">Confidence</span>
              <div className="at__confidence-bar-wrap">
                <div
                  className="at__confidence-bar"
                  style={{ width: `${entry.confidence * 100}%` }}
                />
              </div>
              <span className="at__confidence-value">
                {Math.round(entry.confidence * 100)}%
              </span>
            </div>

            <div className="at__entry-footer">
              <span
                className={`badge badge--${entry.hazardTier} at__hazard-badge`}
              >
                {getRiskLabel(entry.hazardTier)}
              </span>
              {entry.override && (
                <div className="at__override-block">
                  <span className="at__override-label">
                    Override: {entry.override.from} → {entry.override.to}
                  </span>
                  <p className="at__override-reason">{entry.override.reason}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
